import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Transition } from '@headlessui/react'
import React, { Fragment, useState } from 'react'

const CollapsibleTable = (props) => {
    const trip = props.trip ?? null
    const [open, setOpen] = useState(true)

    const thousandSeparator = nStr => {
        return nStr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    return (
        <>
            <div className='group flex flex-col w-full rounded-[10px] cursor-pointer overflow-hidden'>
                <button onClick={() => setOpen(!open)} className="flex p-4 z-10 transition bg-slate-100 group-hover:bg-slate-200">
                    <div className='w-full flex items-center justify-between text-start'>
                        {
                            (trip.trip === 'No Trip Entitled Yet') ?
                            <p className='text-xs font-semibold text-gray-one'>Not Entitled to Any Trip</p> :
                            <p className='text-xs font-semibold text-gray-one'>{ `${trip.agents?.length} Entitled trip to ${ trip.trip }${ trip.minimumCommission > 0 ? ` (RM ${ thousandSeparator(trip.minimumCommission) })` : null }` }</p>
                        }
                        <div className={ 'transform transition-all duration-300 flex items-center ' + (open ? '-rotate-90' : '') }>
                            <FontAwesomeIcon icon={ faChevronRight } className='text-[10px]'/>
                        </div>
                    </div>
                </button>
                
                <Transition as={Fragment} show={open}>
                    <Transition.Child
                        enter="transition ease-linear duration-150 transform"
                        enterFrom="-translate-y-full"
                        enterTo="translate-y-0"
                        leave="transition ease-linear duration-150 transform"
                        leaveFrom="translate-y-0"
                        leaveTo="-translate-y-full"
                    >
                        <div className="transition bg-slate-100 group-hover:bg-slate-200 px-2 pb-2">
                            <div className='rounded-[10px] border border-border overflow-hidden bg-white flex-1'>
                                <div className='overflow-auto'>
                                    <div className='md:w-full w-[878px] flex flex-col'>
                                        <div className='flex items-center border-b border-border bg-secondary-light text-gray-one'>
                                            <div className='flex-[0.3]'>
                                                <p className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-center">#</p>
                                            </div>
                                            <div className='flex-[1.5]'>
                                                <p className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-left">Agent's Name</p>
                                            </div>
                                            <div className='flex-[1.5]'>
                                                <p className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-center">Branch</p>
                                            </div>
                                            {
                                                trip.agents?.length > 0 && trip.agents[0].remaining &&
                                                <div className='flex-1'>
                                                    <p className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-center">Remaining (RM)</p>
                                                </div>
                                            }
                                            <div className='flex-1'>
                                                <p className="text-xs font-semibold px-3 py-2 whitespace-nowrap text-right">Total Commission (RM)</p>
                                            </div>
                                        </div>
                                        <div className='flex flex-col w-full max-h-[164px] overflow-scroll'>
                                            {
                                                trip.agents?.length > 0 ?
                                                trip.agents?.map((item, idx) => {
                                                    return <div key={ `${ trip.trip }_${ item.id }` } className={ 'border-border text-gray-two flex ' + (idx !== 0 ? 'border-t' : '') }>
                                                        <div className="flex-[0.3]">
                                                            <p className='px-3 py-2 whitespace-nowrap text-xs font-medium text-center'>{`${ idx + 1 }`}</p>
                                                        </div>
                                                        <div className="flex-[1.5]">
                                                            <p className='text-xs font-light px-3 py-2 whitespace-nowrap text-left'>{ item?.name }</p>
                                                        </div>
                                                        <div className="flex-[1.5]">
                                                            <p className='text-xs font-light px-3 py-2 whitespace-nowrap text-center'>{ item?.branch }</p>
                                                        </div>
                                                        {
                                                            item.remaining &&
                                                            <div className="flex-1">
                                                                <p className='text-xs font-light px-3 py-2 whitespace-nowrap text-center'>{ thousandSeparator(item?.remaining) }</p>
                                                            </div>
                                                        }
                                    
                                                        <div className="flex-1">
                                                            <p className='text-xs font-light px-3 py-2 whitespace-nowrap text-right'>{ thousandSeparator(item?.totalCommission) }</p>
                                                        </div>
                                                    </div>
                                                }) :
                                                <div className='text-gray-two'>
                                                    <div className="w-full h-full flex items-center justify-center text-xs font-light px-3 py-14 whitespace-nowrap text-center">There is no data</div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                </Transition>
            </div>
        </>
    )
}

export default CollapsibleTable